interface SkeletonProps {
  className?: string;
  lines?: number;
  height?: string;
}

export function Skeleton({ className = '', height = 'h-4' }: SkeletonProps) {
  return (
    <div
      aria-hidden="true"
      className={`skeleton-pulse rounded-md bg-[var(--color-surface-raised)] ${height} ${className}`}
    />
  );
}

export function SkeletonCard({ lines = 3 }: { lines?: number }) {
  return (
    <div className="rounded-xl border bg-[var(--color-surface)] border-[var(--color-border)] p-4 sm:p-6 space-y-3">
      <Skeleton className="w-2/5" height="h-5" />
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} className={i === lines - 1 ? 'w-3/5' : 'w-full'} />
      ))}
    </div>
  );
}

export function SkeletonHero() {
  return (
    <div className="space-y-4" aria-hidden="true">
      <Skeleton className="w-1/3 mx-auto" height="h-4" />
      <Skeleton className="w-2/3 mx-auto" height="h-12" />
      <Skeleton className="w-1/4 mx-auto" height="h-4" />
    </div>
  );
}

export function SkeletonList({ rows = 5 }: { rows?: number }) {
  return (
    <div className="divide-y divide-[var(--color-border)]">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center gap-3 py-3 px-4">
          <Skeleton className="w-8 flex-shrink-0" height="h-8" />
          <div className="flex-1 space-y-2">
            <Skeleton className="w-3/5" height="h-3" />
            <Skeleton className="w-2/5" height="h-3" />
          </div>
          <Skeleton className="w-16 flex-shrink-0" height="h-4" />
        </div>
      ))}
    </div>
  );
}
